export default __webpack_public_path__ + "static/media/yoga.2b9f2c1a.png";